import React from 'react';

import { RemoveIcon } from '../../assets/icons/RemoveIcon';
import { POLLS_REMOVE_ANSWER_BUTTON } from '../../data-hooks';
import styles from './option-scss';

export const RemoveOption = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      type="button"
      data-hook={POLLS_REMOVE_ANSWER_BUTTON}
      onClick={onClick}
      className={styles.removeButton}
    >
      <RemoveIcon className={styles.removeButtonIcon} />
    </button>
  );
};
